module.exports = __webpack_public_path__ + "img/construction-site.19c0ec06.svg";